var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"charts-page",style:({ gridTemplateColumns: _vm.columnTemplate })},_vm._l((_vm.chartTypes),function(types,index){return _c('ChartPageColumn',{key:index,attrs:{"index":index,"useResizer":index < _vm.chartTypes.length - 1,"types":types},on:{"start-resize":_vm.startResize}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }